import { Badge, Button, Footnote, Modal, Toggle } from '../../../components/ui';
import type { FunnelKind } from '../../../types';
import type { EmailAutomation } from '../types';

/**
 * Automacoes de e-mail da regua (T+1h, T+24h... D+90), agrupadas por funil.
 *
 * Ligar e desligar e estado local da previa; o pai guarda os ajustes por id
 * e mostra "Salvo na previa". O texto de cada toque mora no modulo de funis
 * -- aqui so o interruptor, para nao existir duas telas editando a mesma copy.
 */

const FUNIL_LABEL: Readonly<Record<FunnelKind, string>> = {
  carrinho_abandonado: 'Carrinho abandonado',
  expirados: 'Expirados',
};

const ORDEM_FUNIS: readonly FunnelKind[] = ['carrinho_abandonado', 'expirados'];

export function ModalAutomacoesEmail({
  open,
  onClose,
  automacoes,
  onToggle,
  salvoId,
}: {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly automacoes: readonly EmailAutomation[];
  readonly onToggle: (id: string, enabled: boolean) => void;
  readonly salvoId: string | null;
}): JSX.Element | null {
  const ligadas = automacoes.filter((a) => a.enabled).length;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Automações de e-mail"
      description="Os e-mails que saem sozinhos pela régua, junto com o WhatsApp. O texto de cada toque é editado no funil."
      footer={
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      }
    >
      <div className="flex flex-col gap-5">
        <p className="text-sm text-ink-muted">
          <span className="font-semibold text-ink">{ligadas}</span> de {automacoes.length} automações ligadas.
        </p>
        {ORDEM_FUNIS.map((funil) => {
          const doFunil = automacoes.filter((a) => a.funnel === funil);
          if (doFunil.length === 0) {
            return null;
          }
          return (
            <section key={funil} aria-label={FUNIL_LABEL[funil]} className="flex flex-col gap-3">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-ink-subtle">{FUNIL_LABEL[funil]}</h3>
              <ul className="flex flex-col gap-3">
                {doFunil.map((a) => (
                  <li key={a.id} className="rounded-xl border border-line px-4 py-3">
                    <Toggle
                      checked={a.enabled}
                      onChange={(v) => onToggle(a.id, v)}
                      label={
                        <span className="flex flex-wrap items-center gap-2">
                          {a.label}
                          {salvoId === a.id ? (
                            <Badge tone="warning" dot>
                              Salvo na prévia
                            </Badge>
                          ) : null}
                        </span>
                      }
                      description={a.description}
                    />
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
        <Footnote>Enquanto o provedor de e-mail não for definido, as automações ficam registradas mas nenhum e-mail sai.</Footnote>
      </div>
    </Modal>
  );
}
